import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}
  /* Method which returns jwt token */
  public getToken(): string {
    const user = localStorage.getItem('user');
    if (user) {
      return JSON.parse(user)['token'];
    }
    return '';
  }
  /* Method to check token expiry */
  public isAuthenticated(): boolean {
    const token = this.getToken();
    // commented below as we didn't implement token validity
    // return token ? helper.isTokenExpired(token) : false;
    // remove below line if we implement token validity
    return token ? true : false;
  }
  /* Method returns decoded token */
  public getLoggedUserPermissions(): object {
    const token = this.getToken();
    const decoded = helper.decodeToken(token);
    return decoded['permission'];
  }
  /* Method which returns the role of logged user */
  public getLoggedUserRole(): string {
    const token = this.getToken();

    const decoded = helper.decodeToken(token);
    return decoded['role_id'];
  }
  /* Method which returns the name and role of logged user */
  public getLoggedUserInfo(): string {
    const token = this.getToken();
    const decoded = helper.decodeToken(token);
    return decoded ? JSON.stringify(decoded) : '';
  }
  public getResetLoginId(token: string): any {
    const decoded = helper.decodeToken(token);
    return decoded;
  }
}
